// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__ClRV7"};